import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Select from 'components/Select';

import { logout } from 'redux/slices/auth';
import PATHS from 'routes/paths';
import { CustomValueContainer } from 'utils/customComponents';
import './style.css';
import { PROFILE_OPTIONS } from 'utils/selectOptions';

const ProfileDropdown = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user, isLoading } = useSelector((state) => state.auth);

  const onSelect = (item) => {
    if (item.value === 'profile') {
      history.push(PATHS.profile);
    } else if (item.value === 'logout') {
      dispatch(logout());
    }
  };

  return (
    <div
      id="profile-dropdown"
      className={`hidden lg:flex absolute items-center top-12 right-12 justify-end transition-all duration-500 ${
        !user.initials ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <span
        id="username-letters"
        className="inline-flex w-14 h-14 items-center justify-center font-bold text-javelin-gray-dark rounded bg-javelin-blueGray-light shadow-sm"
      >
        {user.initials}
      </span>
      <Select
        options={PROFILE_OPTIONS}
        isSearchable={false}
        isOptionDisabled={() => isLoading}
        onChange={onSelect}
        components={{
          IndicatorSeparator: () => null,
          ValueContainer: CustomValueContainer,
        }}
        placeholder={null}
        value={null}
        controlShouldRenderValue={false}
        name={user.name}
        email={user.email}
        className="profile-dropdown"
      />
    </div>
  );
};

export default memo(ProfileDropdown);
